import SlsTracker from "@aliyun-sls/web-track-browser";
import MD5 from "crypto-js/md5.js";
import browser from "browser-tool";

const createUniqueId = () => {
  const userAgent = window.navigator.userAgent || "";
  const dateTime = Date.now();
  const r1 = Math.random();
  const r2 = Math.random();
  const sessionIdPattern = `${dateTime}##${userAgent}##${r1}##${r2}`;
  return MD5(sessionIdPattern).toString().toLowerCase();
}

const opts = {
  host: "cn-beijing.log.aliyuncs.com",
  project: "k8s-log-jinquan",
  topic: "h5",
  logstore: "h5app-jinquan",
}

const tracker = new SlsTracker(opts)
const { device, browser: browser_type, version, engine, system, systemVersion, isBot, isWebview } = browser()

const commonParams = {
  code_env: process.env.VUE_APP_BASE_URL === "dev" ? "prod" : "dev", // 区分dev/prod
  session_id: createUniqueId(),
  platform_name: "H5",
  device_type: device, // 设备类型：PC(Desktop)/Tablet/Mobile
  browser_type,
  browser_version: version,
  browser_engine: engine, // 引擎
  system_type: system,
  system_version: systemVersion,
  is_bot: +isBot, // 是否为搜索引擎蜘蛛程序
  is_webview: isWebview,
  user_id: localStorage.getItem('user_id') || '',
  biz: localStorage.getItem('biz') || '',
  client_type: localStorage.getItem('client_type') || '',
  app: localStorage.getItem('app') || '',
  pkg_name: localStorage.getItem('pkg_name') || '',
  token: localStorage.getItem('token') || '',
  version: localStorage.getItem('version') || ''
}

// 每次动态变化
const setCommonParams = () => {
  commonParams.act_url = window.location.href; // 当前页面url
  commonParams.event_time = Date.now();
};

export default (event_name, params = {}) => {
  setCommonParams();
  tracker.sendImmediate({
    ...params,
    ...commonParams,
    event_name,
  });
};
